import React from "react";
import SwatahViewer from "./components/ResumeViewer";

function App() {
    return (
        <div>
            <SwatahViewer />
        </div>
    );
}

export default App;